import React from 'react'
import PropTypes from 'prop-types'
import _padStart from 'lodash/padStart'
import moment from 'moment'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { OrderedMap } from 'immutable'

import { getCurrentQueueStatuses } from 'modules/queues/selectors'


const formatDiff = (a, b) => {
  if (!a || !b) {
    return '00:00'
  }

  const diffTime = moment(a.timestamp).diff(moment(b.timestamp));
  const duration = moment.duration(diffTime);
  const parts = ['hours', 'minutes', 'seconds']
    .reduce((res, unit) => {
      res[unit] = _padStart(duration[unit](), 2, '0')
      return res
    }, {});
  const span = `${parts.minutes}:${parts.seconds}`;

  return duration.hours() ? `${parts.hours}:${span}` : span
};

const QueueStatusTimeline = ({ statuses }) => {
  if (!statuses.size) {
    return null;
  }

  return (
    <ul className="list-group statuses-list mb-0">
      {
        statuses
          .map((item, index) => {
            return (
              <li key={ index } className="list-group-item">
                { moment(item.timestamp).format('h:mm:ss a') }
                { !!item.prevKey &&
                  <span className="spent-time ml-3">({ formatDiff(item, statuses.get(item.prevKey)) })</span> }
                <span className="badge badge-default badge-pill ml-3">{ item.status }</span>
              </li>
            )
          },
          ).toArray()
      }
    </ul>
  );
}

QueueStatusTimeline.propTypes = {
  statuses: PropTypes.instanceOf(OrderedMap).isRequired,
};

const mapStateToProps = createStructuredSelector({
  statuses: getCurrentQueueStatuses,
});
export default connect(mapStateToProps)(QueueStatusTimeline)



// WEBPACK FOOTER //
// ./src/components/links/timeline.js